export default () => {
    function address_action_clicked() {
        $('.js-searchResults').show();
        $('.js-results').hide();
        $('.js-spinner').show();
        $('.js-completion-message').hide();
    }

    function refresh_result() {
        $('.js-spinner').hide();
        reset_formfields();
        getAddresses(false);
    }

    function reset_formfields() {
        event.preventDefault();
        $('.js-addressform').find('input[type=text]').val("");
        $('.js-hiddenAddressLineNo').text("");
    }

    function showMessage(string, cssClass) {
        if (cssClass) {
            $('.js-completion-message').addClass(cssClass);
        }
        $('.js-completion-message').html(string);
        $('.js-completion-message').show();
    }

    function load_address_to_form(element) {
        $('.js-add-form').hide();
        $('.js-update-form').show();
        $('.js-cancel-update-address-button').show();
        $('.js-update-form .js-addressNameField').val($(element).closest('tr').find('.js-table-data-addressName').text());
        $('.js-update-form .js-contactName').val($(element).closest('tr').find('.js-table-data-name').text());
        $('.js-update-form .js-contactPhone').val($(element).closest('tr').find('.js-table-data-phone').text());
        $('.js-update-form .js-addressField').val($(element).closest('tr').find('.js-table-data-address').text());
        $('.js-update-form .js-suburbField').val($(element).closest('tr').find('.js-table-data-suburb').text());
        $('.js-update-form .js-stateField').val($(element).closest('tr').find('.js-table-data-state').text());
        $('.js-update-form .js-hiddenAddressLineNo').text($(element).closest('tr').find('.js-table-data-addresslineno').text());
        $('.js-update-form .js-update-address-button').show();
        $('html, body').animate({
            scrollTop: ($('.form-background').offset().top - 120)
        }, 800);
    }

    function cancel_update_address() {
        $('.js-update-form .js-addressNameField').val('');
        $('.js-update-form .js-contactName').val('');
        $('.js-update-form .js-contactPhone').val('');
        $('.js-update-form .js-addressField').val('');
        $('.js-update-form .js-suburbField').val('');
        $('.js-update-form .js-stateField').val('');
        $('.js-update-form .js-hiddenAddressLineNo').text('');
        $('.js-completion-message').hide();
        $('.js-add-form').show();
        $('.js-update-form').hide();
        // $('.js-update-form .js-update-address-button').show();
        // reset_formfields();
        // return true;
    }

    function getAddresses(isSystem) {
        event.preventDefault();
        address_action_clicked();
        $ = jQuery;
        $.ajax({
            type: "POST",
            url: get_url_path('/getAddressesForAddressPage'),
            data: {
                AccCusNo: $('.js-getDetailsFrom').val(),
                isSystem: isSystem
            },
            success: function (response) {
                $('.js-spinner').hide();
                $('.js-addressResults').find('.js-results').html(response);
                $('.js-results').show();
            },
            error: function (response) {
                showMessage("Something was wrong!", "fail");
            }
        });
        return false;
    }

    var validationRules = {
        addressName: "required",
        contactName: "required",
        contactPhone: "required",
        address: "required",
        suburb: "required",
    };
    var validationMessage = {
        addressName: "This is a required field",
        contactName: "This is a required field",
        contactPhone: "This is a required field",
        address: "Please enter the address",
        suburb: "Please enter the suburb, state will be generated automatically",
    }

    function add_address() {
        //event.preventDefault();
        $ = jQuery;
        $('.js-reset-add-address-button').hide();
        var addForm = $('.js-add-form');
        addForm.validate({
            rules: validationRules,
            messages: validationMessage,
            submitHandler: function (form, event) {
                address_action_clicked();
                var AddressName = addForm.find('.js-addressNameField').val();
                var Name = addForm.find('.js-contactName').val();
                var Phone = addForm.find('.js-contactPhone').val();
                var Address = addForm.find('.js-addressField').val();
                var Suburb = addForm.find('.js-suburbField').val();
                var State = addForm.find('.js-stateField').val();
                $.ajax({
                    type: "POST",
                    url: get_url_path('/addAddress'),
                    data: {
                        AccCusNo: $('.js-getDetailsFrom').val(),
                        Name: AddressName,
                        ContactName: Name,
                        ContactPhone: Phone,
                        Address: Address,
                        Suburb: Suburb,
                        State: State,
                    },
                    success: function (response) {
                        $('.js-reset-add-address-button').show();
                        refresh_result();
                    },
                    error: function (response) {
                        showMessage("Something was wrong!", "fail");
                    },
                    complete: function (response) {
                        showMessage("Address has been added successfully!", "success");
                    }
                });
                return false;
            }
        });
        return;
    }

    function delete_address(addressLineNo) {
        if (addressLineNo) {
            if (confirm("Do you want to delete this address?")) {
                address_action_clicked();
                var accCusNo = window.localStorage.getItem('AccCusNo');
                $.ajax({
                    type: "POST",
                    url: get_url_path('/deleteAddress'),
                    data: {
                        AccCusNo: $('.js-getDetailsFrom').val(),
                        AddressLineNo: addressLineNo
                    },
                    success: function (response) {
                        refresh_result();
                    },
                    error: function (response) {
                        showMessage("Something was wrong!", "fail");
                    },
                    complete: function (response) {
                        showMessage("Address is deleted!", "success");
                    }
                });
                return false;
            }
            return false;
        } else {
            alert("Sorry, you cannot delete this address!");
        }
    }

    function update_address() {
        $ = jQuery;
        $('.js-cancel-update-address-button').hide();
        var updateForm = $('.js-update-form');
        updateForm.validate({
            rules: validationRules,
            messages: validationMessage,
            submitHandler: function (form, event) {
                address_action_clicked();
                var AddressName = updateForm.find('.js-addressNameField').val();
                var Name = updateForm.find('.js-contactName').val();
                var Phone = updateForm.find('.js-contactPhone').val();
                var Address = updateForm.find('.js-addressField').val();
                var Suburb = updateForm.find('.js-suburbField').val();
                var State = updateForm.find('.js-stateField').val();
                var AddressLineNo = updateForm.find('.js-hiddenAddressLineNo').text();
                $.ajax({
                    type: "POST",
                    url: get_url_path('/updateAddress'),
                    data: {
                        AccCusNo: $('.js-getDetailsFrom').val(),
                        Name: AddressName,
                        Address: Address,
                        ContactName: Name,
                        ContactPhone: Phone,
                        Suburb: Suburb,
                        State: State,
                        AddressLineNo: AddressLineNo
                    },
                    success: function (response) {
                        if (response) {
                            $('.js-update-form').hide();
                            $('.js-add-form').show();
                            refresh_result();
                        }
                    },
                    error: function (response) {
                        showMessage("Something was wrong!", "fail");
                    },
                    complete: function (response) {
                        showMessage("Address has been updated successfully!", "success");
                    }
                });
                return false;
            }
        });
        return;
    }

    $(function () {
        if ($('.js-suburbField').length) {
            $('.js-suburbField').on('input propertychange paste',
                initSuburbAutocomplete($('.js-suburbField'), {
                    response: function (ev, ui) {
                        $.each(ui.content, function (index, item) {
                            item.value = item.suburb;
                        });
                    },
                    select: function (ev, ui) {
                        $('.js-suburbField').val(ui.item['suburb'])
                        $('.js-stateField').val(ui.item['state']);
                        $('.js-postCode').val(ui.item['postcode']);
                    }
                }));
        }
    });

    function initSuburbAutocomplete(els, opts) {
        var defaults = {
            source: get_url_path('/getSuburb'),
            minLength: 3,
        };
        $.extend(defaults, opts);
        els.autocomplete(defaults);
    }

    function get_url_path(append) {
        var append = append ? append : '';
        var home = (window.location.pathname == '' || window.location.pathname == '/') ? '/home' : '';
        return window.location.pathname.replace(/\/$/, '') + home + append;
    };

    function validate_address_fields() {
        $("form[name='address-form']").validate({
            // Specify validation rules
            rules: {
                addressName: "required",
                contactName: "required",
                contactPhone: "required",
                address: "required",
                suburb: "required",
                state: "required"
            },
            // Specify validation error messages
            messages: {
                addressName: "This is a required field",
                contactName: "This is a required field",
                contactPhone: "This is a required field",
                address: "This is a required field",
                suburb: "This is a required field",
                state: "This is a required field"
            },
        });
    }
}
